import {
  PublicClientApplication,
  type AuthenticationResult,
  type SilentRequest,
} from "@azure/msal-browser";

const MOCK_AUTH = import.meta.env.VITE_PLAYWRIGHT_TESTING_MODE === "true";

export function getMsalInstance(
  azureAdClientId: string
): PublicClientApplication {
  const msalConfig = {
    auth: {
      clientId: azureAdClientId,
      authority:
        "https://login.microsoftonline.com/ffd682b2-afb6-4bb2-9c9f-573a10bf18be",
      redirectUri: globalThis.location.origin,
    },
  };

  return new PublicClientApplication(msalConfig);
}

export const acquireToken = async (
  azureAdClientId: string,
  apiAppIdUri: string
): Promise<string> => {
  if (MOCK_AUTH) {
    return "mock-access-token";
  }

  const msalInstance = getMsalInstance(azureAdClientId);

  if (!msalInstance) {
    throw new Error("MSAL instance is not initialized");
  }

  await msalInstance.initialize();

  const accounts = msalInstance.getAllAccounts();

  if (accounts.length === 0) throw new Error("No user accounts found");

  const request: SilentRequest = {
    account: accounts[0],
    scopes: [`${apiAppIdUri}/.default`],
    redirectUri: `https://${globalThis.location.host}`,
  };

  const response: AuthenticationResult = await msalInstance.acquireTokenSilent(
    request
  );
  return response.accessToken;
};
